import { createContext, useContext } from "react";

/**
 * Context indicating whether the shell's fixed BottomNavigation is currently displayed.
 * When `false` (e.g. on detail pages), `StickyActionBar` automatically docks to `viewport` (bottom-0)
 * rather than floating above the non-existent bottom nav.
 */
export const BottomNavContext = createContext<boolean>(true);

export function useBottomNavVisibility(): boolean {
  return useContext(BottomNavContext);
}
